import { BaseService } from './base-service';
export class ReportsService {
    static exportExcelActivities(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        let dateString = (new Date()).toISOString().replace(/[:\.]/g, '');
        let filename = "attività_" + dateString + ".xlsx";
        BaseService.downloadFile(`reports/export-excel/activities?filter=${qs}`, filename, null);
    }
    static exportExcelGeneral(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        let dateString = (new Date()).toISOString().replace(/[:\.]/g, '');
        let filename = "generale_" + dateString + ".xlsx";
        BaseService.downloadFile(`reports/export-excel/general?filter=${qs}`, filename, null);
    }
}
